import React, {
	Component
} from 'react'
import {
	Form,
	Row,
	Col,
	Input, InputNumber, Select, Checkbox,
	Button, Table, Popconfirm, Modal, Radio,
	Icon, Card,
	Collapse
} from 'antd';
import { uuid } from '../../common/CommonFunc'
import { UserModal } from '../../common/UserModal'
import { RoleModal } from '../../common/RoleModal'
import PubInfo from '../../Component/PubInfo'
const FormItem = Form.Item;
const Panel = Collapse.Panel;
const Option = Select.Option;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
class TaskNodeFrom extends Component {
	constructor(props) {
		super(props)
		this.state = {
			node: props.node,
			show: props.show != null && props.show == true ? props.show : 'none',
			nodedata: props.nodedata,
			roleOption: this.getRoleOption(props.nodedata.orgtype),
			loading: false
		}
	}


	getRoleOption(orgtype) {
		tool.sgiLogger.log("getRoleOption====orgtype", orgtype);

		//初始给医院、医药公司的查询地址与请求信息
		let req = {
			values: { lesseeType: orgtype }, // 租户类型
			matchs: {},
			batch: false
		};

		// let url = "http://100.1.1.27:8088/lesuam/LesseeRoleTpl/list";
		let url = sgiConfig.service_baseuam + "LesseeRoleTpl/list";

		//如果是医保局、则更改查询地址与请求信息
		if (orgtype == "10") {
			req = {
				values: {},
				matchs: {},
				batch: false
			}
			// url = "http://100.1.1.27:8088/lesuam/role/list";
			url = sgiConfig.service_baseuam + "role/list";
		}

		let arr = [];
		commonClient.simplecall(url, req, function (res) {
			if (res && res.head && res.head.code == "0000") {
				tool.sgiLogger.log("根据租户类型查询角色成功！res：", res);
				let datas = res.body || [];
				tool.sgiLogger.log("datas", datas);

				for (let index = 0; index < datas.length; index++) {
					let element = datas[index];
					arr.push(<Option value={element.roleId}>{element.roleName}</Option>);
				}
				tool.sgiLogger.log("arr", arr);

			} else {
				tool.sgiLogger.error("根据租户类型查询角色失败！res：", res);
			}
		})

		return arr;
	}


	setValues(values) {


	}
	// 重新加载页面方法
	reload = () => {
		this.setState({ loading: false });
	}
	// 文本修改事件
	textOnChange(attname, e, e2) {
		tool.sgiLogger.log("事件：textOnChange")
		let value = e.target.value;
		this.refresh(attname, value);
	}
	// 下拉窗修改事件
	selectOnChange = (attname, value) => {//change传入对象为value
		tool.sgiLogger.log("事件：selectOnChange")
		this.refresh(attname, value);
	}

	//下拉窗修改事件2
	selectOnChange2 = (attname, value) => {//change传入对象为value
		let me = this;
		tool.sgiLogger.log("事件：selectOnChange")

		//初始给医院、医药公司的查询地址与请求信息
		let req = {
			values: { lesseeType: value }, // 租户类型
			matchs: {},
			batch: false
		};

		// let url = "http://100.1.1.27:8088/lesuam/LesseeRoleTpl/list";
		let url = sgiConfig.service_baseuam + "LesseeRoleTpl/list";

		//如果是医保局、则更改查询地址与请求信息
		if (value == "10") {
			req = {
				values: {},
				matchs: {},
				batch: false
			}
			// url = "http://100.1.1.27:8088/lesuam/role/list";
			url = sgiConfig.service_baseuam + "role/list";
		}

		commonClient.simplecall(url, req, function (res) {
			if (res && res.head && res.head.code == "0000") {
				tool.sgiLogger.log("根据租户类型查询角色成功！res：", res);
				let datas = res.body || [];
				tool.sgiLogger.log("datas", datas);

				let arr = [];
				for (let index = 0; index < datas.length; index++) {
					let element = datas[index];
					arr.push(<Option value={element.roleId}>{element.roleName}</Option>);
				}

				tool.sgiLogger.log("arr", arr);
				// this.refresh("roleOption", arr);
				me.state.roleOption = arr;

			} else {
				tool.sgiLogger.error("根据租户类型查询角色失败！res：", res);
			}
		})
		tool.sgiLogger.log("执行完毕！")

		this.refresh(attname, value);
	}

	// 复选框组修改事件，checkedValue为数组["01","02"]
	checkboxGroupOnChange = (attname, checkedValue) => {
		tool.sgiLogger.log("事件：checkboxGroupOnChange")
		this.refresh(attname, checkedValue);
	}
	// 单选框组修改事件
	radioGroupOnChange(attname, e) {
		tool.sgiLogger.log("事件：radioGroupOnChange")
		let value = e.target.value;
		this.refresh(attname, value);
	}
	// 数字组件修改事件
	numberOnChange(attname, e) {
		let value = e;
		this.refresh(attname, value);
	}
	// 属性更新
	refresh(attname, value) {
		if (attname === 'name' && this.state.nodedata[attname] != value) this.state.node.setText(this.state.node.data.id + " " + value);
		this.state.nodedata[attname] = value;
	}
	// 表格添加方法
	handleAdd = (modalType) => {
		tool.sgiLogger.log("handleAdd添加审批人/角色方法");
		if (!modalType || modalType == '') {
			this.state.modalContent = null;
		}
		if (modalType == 'user') {
			this.state.modalContent = <UserModal key={uuid(8)} modalShow={true} title='选择审批人员'
				approvalUserList={this.state.nodedata.users} parent={this} />
		} else if (modalType == 'role') {
			this.state.modalContent = <RoleModal key={uuid(8)} modalShow={true} title='选择审批角色'
				approvalRoleList={this.state.nodedata.roles} parent={this} />
		} else if (modalType == 'overTimeout') {
			this.state.modalContent = <UserModal key={uuid(8)} modalShow={true} title='选择提醒人员'
				approvalUserList={this.state.nodedata.overTimeoutUsers} parent={this} />
		} else if (modalType == 'human') {
			this.state.modalContent = <UserModal key={uuid(8)} modalShow={true} title="选择操作人员"
				approvalUserList={this.state.nodedata.human} parent={this} />
		}
		this.setState({
			loading: false
		});
	}
	// 表格删除方法
	handleDelete = (delData, dataSource) => {
		if (dataSource && delData) {
			for (var i = 0; i < dataSource.length; i++) {
				if (delData == dataSource[i] || delData._key == dataSource[i]._key) {
					dataSource.splice(i, 1);
				}
			}
		}
		this.setState({ loading: false });
	}
	// 创建表格绑定store（生成数据key）
	getTBData = (tData) => {
		if (!tData) {
			tData = [];
			return tData;
		}
		tData.forEach(element => {
			if (!element._key) element._key = uuid(8);
		})
		return tData;
	}
	// 刷新form
	componentDidMount() {
		tool.sgiLogger.log('事件：taskNode加载后')
		this.props.form.setFieldsValue({
			executionInterface: this.state.nodedata.executionInterface,
			executionInterfaceparm: this.state.nodedata.executionInterfaceparm,
			tasktype: this.state.nodedata.tasktype,
			approvalstrategy: this.state.nodedata.approvalstrategy,
			approvalweight: this.state.nodedata.approvalweight,
			ismodiapproval: this.state.nodedata.ismodiapproval,
			isentrust: this.state.nodedata.isentrust,
			isjump: this.state.nodedata.isjump,

			remindMode: this.state.nodedata.remindMode,
			remindTime: this.state.nodedata.remindTime,
			remindCycle: this.state.nodedata.remindCycle,

			overTimeout: this.state.nodedata.overTimeout,
			overTimeoutHandling: this.state.nodedata.overTimeoutHandling,
			// overTimeoutUsers: this.state.nodedata.overTimeoutUsers,

			receiveTimeout: this.state.nodedata.receiveTimeout,
			receiveTimeoutHandling: this.state.nodedata.receiveTimeoutHandling,

			ishuman: this.state.nodedata.ishuman,
			handling: this.state.nodedata.handling,
			userrule: this.state.nodedata.userrule,


			orgkey: this.state.nodedata.orgkey,
			orgtype: this.state.nodedata.orgtype,
			rolekey: this.state.nodedata.rolekey,

			// interventionUsers: this.state.nodedata.interventionUsers

		});
	}

	// 表格下拉窗修改事件
	selectOnChangeTb(record, attname, value, e) {
		tool.sgiLogger.log("事件：selectOnChangeTb")
		record[attname] = value;
		tool.sgiLogger.log('record :', record);
		this.setState({});
	}

	render() {
		const { getFieldDecorator } = this.props.form;
		const userList = this.getTBData(this.state.nodedata.users);
		const userListColumns = [
			{
				title: '用户名称', // 列头显示名称
				dataIndex: 'empName' // 列数据在数据项中对应的 key
			},
			{
				title: '操作',
				key: 'action',
				render: (text, record) => (
					this.state.nodedata.users.length >= 1
						? (
							<Popconfirm title="确认删除?" onConfirm={() => this.handleDelete(record, this.state.nodedata.users)}>
								<a href="javascript:;">删除</a>
							</Popconfirm>
						) : null
				),
			}
		];
		const roleList = this.getTBData(this.state.nodedata.roles);
		const roleListColumns = [
			{
				title: '角色名称', // 列头显示名称
				dataIndex: 'roleName' // 列数据在数据项中对应的 key
			},
			{
				title: '类型', // 列头显示名称
				dataIndex: 'deptFlag', // 列数据在数据项中对应的 key
				render: (text, record, index) => {
					return (
						<Select placeholder="请选择类型" value={text}
							onChange={this.selectOnChangeTb.bind(this, record, "deptFlag")}
						>
							<Option value="01">本机构</Option>
							<Option value="02">上级机构</Option>
						</Select>
					)
				}
			},
			{
				title: '操作',
				key: 'action',
				render: (text, record) => (
					this.state.nodedata.roles.length >= 1
						? (
							<Popconfirm title="确认删除?" onConfirm={() => this.handleDelete(record, this.state.nodedata.roles)}>
								<a href="javascript:;">删除</a>
							</Popconfirm>
						) : null
				),
			}
		];

		const overTimeoutUsers = this.getTBData(this.state.nodedata.overTimeoutUsers);
		const timeoutUserListColumns = [
			{
				title: '用户名称', // 列头显示名称
				dataIndex: 'empName' // 列数据在数据项中对应的 key
			},
			{
				title: '操作',
				key: 'action',
				render: (text, record) => (
					this.state.nodedata.overTimeoutUsers.length >= 1
						? (
							<Popconfirm title="确认删除?" onConfirm={() => this.handleDelete(record, this.state.nodedata.overTimeoutUsers)}>
								<a href="javascript:;">删除</a>
							</Popconfirm>
						) : null
				),
			}
		];

		const human = this.getTBData(this.state.nodedata.human);
		const interventionUserListColumns = [
			{
				title: '用户名称', // 列头显示名称
				dataIndex: 'empName' // 列数据在数据项中对应的 key
			},
			{
				title: '操作',
				key: 'action',
				render: (text, record) => (
					this.state.nodedata.human.length >= 1
						? (
							<Popconfirm title="确认删除?" onConfirm={() => this.handleDelete(record, this.state.nodedata.human)}>
								<a href="javascript:;">删除</a>
							</Popconfirm>
						) : null
				),
			}
		];
		return (
			<div style={{ display: this.state.show }}>
				<Form layout="vertical" >
					<Collapse defaultActiveKey={['1']} >
						<Panel header="通用节点信息" key="1">
							<PubInfo parent={this} node={this.state.node} nodedata={this.state.nodedata} />
						</Panel>
						<Panel header="任务节点信息" key="2">
							<Row gutter={16}>
								<Col span={24}>
									<Form.Item label="执行界面">
										{getFieldDecorator('executionInterface', {
											rules: [{ required: false, message: '请输入执行界面' }],
										})(<Input placeholder="执行界面"
											onChange={this.textOnChange.bind(this, 'executionInterface')}
										/>)}
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={16}>
								<Col span={24}>
									<Form.Item label="界面启动参数">
										{getFieldDecorator('executionInterfaceparm', {
											rules: [{ required: false, message: '请输入界面启动参数' }],
										})(<Input placeholder="界面启动参数"
											onChange={this.textOnChange.bind(this, 'executionInterfaceparm')}
										/>)}
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={16}>
								<Col span={12}>
									<Form.Item label="任务类型">
										{getFieldDecorator('tasktype', {
											rules: [{ required: true, message: 'Please select an owner' }],
										})(
											<Select placeholder="请选择任务类型"
												onChange={this.selectOnChange.bind(this, 'tasktype')}
											>
												<Option value="01">普通任务</Option>
												<Option value="02">审批任务</Option>
											</Select>
										)}
									</Form.Item>
								</Col>
								{this.state.nodedata.tasktype == "02" ?
									<Col span={12}>
										<Form.Item label="审批人修改">
											{getFieldDecorator('ismodiapproval', {
												rules: [{ required: false, message: '是否允许修改审批人' }],
											})(
												<RadioGroup onChange={this.radioGroupOnChange.bind(this, 'ismodiapproval')} >
													<Radio value={"0"}>不允许</Radio>
													<Radio value={"1"}>允许</Radio>
												</RadioGroup>
											)}
										</Form.Item>
									</Col>

									: <Col span={12}></Col>
								}
							</Row>
							{this.state.nodedata.tasktype == "02" ?
								<Row gutter={16}>
									<Col span={12}>
										<Form.Item label="审批策略">
											{getFieldDecorator('approvalstrategy', {
												rules: [{ required: false, message: '请输入审批策略' }],
											})(
												<Select placeholder="请选择节点状态"
													onChange={this.selectOnChange.bind(this, 'approvalstrategy')}
												>
													<Option value="0">全部通过</Option>
													<Option value="1">一票通过</Option>
													<Option value="2">一票否决</Option>
													<Option value="3">少数服从多数</Option>
													<Option value="4">权重</Option>
												</Select>
											)}
										</Form.Item>
									</Col>
									{this.state.nodedata.approvalstrategy == "4" ?
										<Col span={12}>
											<Form.Item label="审批权重">
												{getFieldDecorator('approvalweight', {
													rules: [{ required: false, message: '请输入审批权重' }],
												})(
													<Input placeholder="审批权重"
														onChange={this.textOnChange.bind(this, 'approvalweight')}
													/>
												)}
											</Form.Item>
										</Col>
										: <Col span={12}></Col>}
								</Row>
								: ""}
							<Row gutter={16}>
								<Col span={12}>
									<Form.Item label="允许委托">
										{getFieldDecorator('isentrust', {
											rules: [{ required: true, message: 'Please select an owner' }],
										})(
											<RadioGroup onChange={this.radioGroupOnChange.bind(this, 'isentrust')} >
												<Radio value={"0"}>不允许</Radio>
												<Radio value={"1"}>允许</Radio>
											</RadioGroup>
										)}
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item label="允许跳转">
										{getFieldDecorator('isjump', {
											rules: [{ required: true, message: '允许跳转' }],
										})(
											<RadioGroup onChange={this.radioGroupOnChange.bind(this, 'isjump')} >
												<Radio value={"0"}>不允许</Radio>
												<Radio value={"1"}>允许</Radio>
											</RadioGroup>
										)}
									</Form.Item>
								</Col>
							</Row>
						</Panel>
						<Panel header="参与人" key="3">
							<Row gutter={16}>
								<Col span={24}>
									<Form.Item label="规则">
										{getFieldDecorator('userrule', {
											rules: [{ required: false, message: '' }],
										})(
											<RadioGroup onChange={this.radioGroupOnChange.bind(this, 'userrule')} >
												<Radio value={"0"}>节点配置</Radio>
												<Radio value={"1"}>业务数据获取</Radio>
												<Radio value={"2"}>业务数据优先节点配置</Radio>
											</RadioGroup>
										)}
									</Form.Item>
								</Col>
							</Row>
							{this.state.nodedata.userrule != "0" ?
								<Row gutter={16}>
									<Col span={24}>
										<Form.Item label="企业key">
											{getFieldDecorator('orgkey', {
												rules: [{ required: false, message: '企业key' }],
											})(
												<Input
													style={{ width: '100%' }}
													placeholder="企业key"
													onChange={this.textOnChange.bind(this, 'orgkey')}
												/>
											)}
										</Form.Item>
									</Col>

									<Col span={24}>
										<Form.Item label="企业类型">
											{getFieldDecorator('orgtype', {
												rules: [{ required: false, message: '企业类型' }],
											})(
												<Select
													style={{ width: '100%' }}
													placeholder="企业类型"
													onChange={this.selectOnChange2.bind(this, 'orgtype')}
												>
													<Option value="10">医保局</Option>
													<Option value="20">医疗机构</Option>
													<Option value="30">医药公司</Option>
												</Select>
											)}
										</Form.Item>
									</Col>

									<Col span={24}>
										<Form.Item label="角色">
											{getFieldDecorator('rolekey', {
												rules: [{ required: false, message: '角色' }],
											})(
												<Select
													placeholder="角色"
													mode="multiple"
													allowClear
													style={{ width: '100%' }}
													onChange={this.checkboxGroupOnChange.bind(this, 'rolekey')}
												>
													{this.state.roleOption}
												</Select>
											)}
										</Form.Item>
									</Col>
								</Row>
								: ""}
							{this.state.nodedata.userrule != "1" ?
								<Row gutter={16}>
									<Col span={24}>
										<Button size="small" onClick={this.handleAdd.bind(this, "role")} type="primary" style={{ marginBottom: 10 }}>
											添加参与角色
									</Button>
										<Table size="small" rowKey={"_key"}
											rowClassName={() => 'roleList-row'} // 表格行的类名
											bordered // 是否展示外边框和列边框
											dataSource={roleList}
											columns={roleListColumns}
										/>
									</Col>
								</Row>
								: ""}
							{this.state.nodedata.userrule != "1" ?
								<Row gutter={16}>
									<Col span={24}>
										<Button size="small" onClick={this.handleAdd.bind(this, "user")} type="primary" style={{ marginBottom: 10 }}>
											添加参与人
									</Button>
										<Table size="small" rowKey={"_key"}
											rowClassName={() => 'userList-row'} // 表格行的类名
											bordered // 是否展示外边框和列边框
											dataSource={userList}
											columns={userListColumns}
										/>
									</Col>
								</Row>
								: ""}
						</Panel>
						<Panel header="提醒策略" key="4" >
							<Row gutter={16}>
								<Col span={24}>
									<Form.Item label="提醒方式">
										{getFieldDecorator('remindMode', {
											rules: [{ required: false, message: '' }],
										})(
											<CheckboxGroup onChange={this.checkboxGroupOnChange.bind(this, 'remindMode')} >
												<Checkbox value={"01"}>短信</Checkbox>
												<Checkbox value={"02"}>邮件</Checkbox>
												<Checkbox value={"03"}>电话</Checkbox>
												<Checkbox value={"04"}>微信</Checkbox>
												<Checkbox value={"99"}>其他</Checkbox>
											</CheckboxGroup>
										)}
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={16}>
								<Col span={24}>
									<Form.Item label="提醒时间">
										{getFieldDecorator('remindTime', {
											rules: [{ required: false, message: '' }],
										})(
											<Select placeholder="请选择提醒时间"
												onChange={this.selectOnChange.bind(this, 'remindTime')}
											>
												<Option value="01">立即提醒</Option>
												<Option value="02">10分钟后</Option>
												<Option value="03">30分钟后</Option>
											</Select>
										)}
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={16}>
								<Col span={24}>
									<Form.Item label="提醒周期">
										{getFieldDecorator('remindCycle', {
											rules: [{ required: false, message: '' }],
										})(
											<Select placeholder="请选择提醒周期"
												onChange={this.selectOnChange.bind(this, 'remindCycle')}
											>
												<Option value="01">不重复</Option>
												<Option value="02">每10分钟</Option>
												<Option value="03">每30分钟</Option>
												<Option value="04">每60分钟</Option>
											</Select>
										)}
									</Form.Item>
								</Col>
							</Row>
						</Panel>
						<Panel header="超时策略" key="5">
							<Row gutter={16}>
								<Card title="接收超时">
									<Row gutter={16}>
										<Col span={12}>
											<Form.Item label="接收超时时限">
												{getFieldDecorator('receiveTimeout ', {
													initialValue: this.state.nodedata.receiveTimeout,
													rules: [{ required: false, message: '请输入超时时限' }],
												})(
													<InputNumber
														min={0}
														onChange={this.numberOnChange.bind(this, "receiveTimeout")}
													/>
												)}<span> 分钟</span>
											</Form.Item>
										</Col>
										<Col span={12}>
											<Form.Item label="超时处理规则">
												{getFieldDecorator('receiveTimeoutHandling', {
													rules: [{ required: false, message: '' }],
												})(
													<Select placeholder="请选择超时处理规则"
														onChange={this.selectOnChange.bind(this, 'receiveTimeoutHandling')}
													>
														<Option value="01">不处理</Option>
														<Option value="02">向创建人发消息</Option>
														<Option value="03">返回给创建人</Option>
													</Select>
												)}
											</Form.Item>
										</Col>
									</Row>
								</Card>
							</Row>
							<Row gutter={16}>
								<Card title="完成超时">
									<Row gutter={16}>
										<Col span={12}>
											<Form.Item label="完成超时时限">
												{getFieldDecorator('overTimeout ', {
													initialValue: this.state.nodedata.overTimeout,
													rules: [{ required: false, message: '请输入超时时限' }],
												})(
													<InputNumber
														min={0}
														onChange={this.numberOnChange.bind(this, "overTimeout")}
													/>
												)}<span> 分钟</span>
											</Form.Item>
										</Col>
										<Col span={12}>
											<Form.Item label="超时处理规则">
												{getFieldDecorator('overTimeoutHandling', {
													rules: [{ required: false, message: '' }],
												})(

													<Select placeholder="请选择超时处理规则"
														onChange={this.selectOnChange.bind(this, 'overTimeoutHandling')}
													>
														<Option value="01">不处理</Option>
														<Option value="02">自动向下运行</Option>
														<Option value="03">向创建人发消息</Option>
														<Option value="04">返回给创建人</Option>
														<Option value="05">向接收人员发消息</Option>
														<Option value="06">向指定的人员发消息</Option>
													</Select>
												)}
											</Form.Item>
										</Col>
									</Row>
									{this.state.nodedata.overTimeoutHandling == "06" ?
										<Row gutter={16}>
											<Col span={24}>
												<Button size="small" onClick={this.handleAdd.bind(this, "overTimeout")} type="primary" style={{ marginBottom: 10 }}>
													添加提醒人员
											</Button>
												<Table size="small" rowKey={"_key"}
													rowClassName={() => 'userList-row'} // 表格行的类名
													bordered // 是否展示外边框和列边框
													dataSource={overTimeoutUsers}
													columns={timeoutUserListColumns}
												/>
											</Col>
										</Row>
										: ""}
								</Card>
							</Row>
						</Panel>
						<Panel header="干预策略" key="6" >
							<Row gutter={16}>
								<Col span={24}>
									<Form.Item label="人工干预">
										{getFieldDecorator('ishuman', {
											rules: [{ required: false, message: '' }],
										})(
											<RadioGroup onChange={this.radioGroupOnChange.bind(this, 'ishuman')} >
												<Radio value={"0"}>不允许</Radio>
												<Radio value={"1"}>允许</Radio>
											</RadioGroup>
										)}
									</Form.Item>
								</Col>
							</Row>
							{this.state.nodedata.ishuman == "1" ?
								<Row gutter={16}>
									<Col span={24}>
										<Form.Item label="处理规则">
											{getFieldDecorator('handling', {
												rules: [{ required: false, message: '' }],
											})(
												<CheckboxGroup onChange={this.checkboxGroupOnChange.bind(this, 'handling')} >
													<Row>
														<Col span={6}><Checkbox value={"01"}>完成节点</Checkbox></Col>
														<Col span={6}><Checkbox value={"02"}>回退处理</Checkbox></Col>
														<Col span={6}><Checkbox value={"03"}>重新执行</Checkbox></Col>
														<Col span={6}><Checkbox value={"04"}>督促执行</Checkbox></Col>
														<Col span={6}><Checkbox value={"05"}>任务重新分配</Checkbox></Col>
														<Col span={6}><Checkbox value={"06"}>创建任务</Checkbox></Col>
														<Col span={6}><Checkbox value={"07"}>取消任务</Checkbox></Col>
													</Row>
												</CheckboxGroup>
											)}
										</Form.Item>
									</Col>
								</Row> : ""}
							{this.state.nodedata.ishuman == "1" ?
								<Row gutter={16}>
									<Col span={24}>
										<Button size="small" onClick={this.handleAdd.bind(this, "human")} type="primary" style={{ marginBottom: 10 }}>
											添加操作人员
									</Button>
										<Table size="small" rowKey={"_key"}
											rowClassName={() => 'userList-row'} // 表格行的类名
											bordered // 是否展示外边框和列边框
											dataSource={human}
											columns={interventionUserListColumns}
										/>
									</Col>
								</Row>
								: ""}
						</Panel>
					</Collapse>
				</Form>
				{this.state.modalContent}
			</div>
		)
	}
}

const TaskNode = Form.create()(TaskNodeFrom);

export default TaskNode;


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiFlow/Workflow/Component/TaskNode.js